import * as React from 'react';
import { useContext, useEffect } from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { useTranslation } from 'react-i18next';
import { ScreenName, StackName } from '../types';
import { ArticleScreen, ArticlesScreen, PostFilterScreen } from '../../screens';
import { isMobile } from '../../utils/responsive';
import { StackHeader } from '../../components';
import { NavigationContextStack } from '../../contexts/NavigationContext/NavigationContextStack';

const ArticlesStack = createStackNavigator();

export default function ArticlesStackNavigator({ navigation, route }) {
  const { t } = useTranslation();
  const { setChangedStack } = useContext(NavigationContextStack);

  const eventListener = isMobile ? 'focus' : 'blur';

  // Saving the current stack in a context
  useEffect(() => {
    return navigation.addListener(eventListener, () => {
      setChangedStack(StackName.ArticlesStack);
    });
  }, [navigation]);

  return (
    <ArticlesStack.Navigator
      screenOptions={{
        gestureEnabled: true, // Ensures the swipe gesture is enabled
        headerShown: false,
      }}
    >
      <ArticlesStack.Screen
        name={ScreenName.ArticlesScreen}
        component={ArticlesScreen}
        options={({ navigation }) => {
          return {
            gestureEnabled: true,
            headerShown: isMobile,
            header: () => {
              return (
                <StackHeader
                  navigation={navigation}
                  headerTitle={t('articles:title')}
                  fromScreen={ScreenName.ArticlesScreen}
                />
              );
            },
            title: t('articles:title'),
          };
        }}
      />

      <ArticlesStack.Screen
        name={ScreenName.ArticleScreen}
        component={ArticleScreen}
        options={({ navigation }) => {
          return {
            gestureEnabled: true,
            headerShown: isMobile,
            header: () => {
              return <StackHeader navigation={navigation} />;
            },
          };
        }}
      />
      <ArticlesStack.Screen
        name={ScreenName.PostFilterScreen}
        component={PostFilterScreen}
        options={({ navigation }) => {
          return {
            gestureEnabled: true,
            headerShown: isMobile,
            header: () => {
              return <StackHeader navigation={navigation} headerTitle={t('common:search')} />;
            },
          };
        }}
      />
    </ArticlesStack.Navigator>
  );
}
